module.exports = __webpack_public_path__ + "img/IOS coming soon.6164891c.png";